export enum SupportedMimeType {
    PDF = 'application/pdf',
    TXT = 'text/plain',
    HTML = 'text/html',
    JPG = 'image/jpg',
    JPEG = 'image/jpeg',
    BMP = 'image/bmp',
    PNG = 'image/png',
    GIF = 'image/gif',
    TIFF = 'image/tiff',
}

export enum NgDpMimeType {
    PDF = 'application/pdf',
    TXT = 'text/plain',
    HTML = 'text/html',
    WORD = 'application/msword',
    DOCX = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    RTF = 'application/rtf',
    BMP = 'image/bmp',
    GIF = 'image/gif',
    JPG = 'image/jpg',
    JPEG = 'image/jpeg',
    PNG = 'image/png',
    TIFF = 'image/tiff',
    EXCEL = 'application/vnd.ms-excel',
    XLXS = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    ODT = 'application/vnd.oasis.opendocument.text',
    ODS = 'application/vnd.oasis.opendocument.spreadsheet',
    IMAGEALL = 'image/*',

    // keeping below file types commented for now as it is not required.
    // In future if these extented file types are required in this enum, kindly uncommnet these filetypes.

    // CSV	= 'text/csv',
    // ICAL = 'text/calendar',
    // MOV	= 'video/quicktime',
    // MP3	= 'audio/mpeg',
    // MP4	= 'video/mp4',
    // WAV	= 'audio/wav',
    // XML	= 'application/xml',
    // DDD	= 'application/vnd.fujixerox.ddd',
    // DTA	= 'application/x-stata-dta',
    // ICS = 'text/calendar',
    // SAV	= 'application/x-spss-sav',
}

export const NgDpFileTypes = [
    'pdf',
    'txt',
    'html',
    'htm',
    'doc',
    'docx',
    'rtf',
    'bmp',
    'gif',
    'jpg',
    'jpeg',
    'png',
    'tiff',
    'xls',
    'xlsx',
    'odt',
    'ods',
    'csv',
    'ics',
    'mov',
    'mp3',
    'mp4',
    'wav',
    'xml',
    'ddd',
    'dta',
    'ical',
    'sav',
];
